import { useState } from "react";
import { Link } from "react-router-dom";
import NavBar from "@/components/NavBar";
import api, { formatErr } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setErr(formatErr(e));
    } finally { setLoading(false); }
  };

  return (
    <div className="App" data-testid="page-forgot-password">
      <NavBar />
      <section className="max-w-3xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <div className="aa-eyebrow mb-4">Password reset</div>
        <h1 className="font-display text-4xl lg:text-5xl leading-tight">
          Send me a <span className="serif-italic">reset link</span>.
        </h1>
        <p className="mt-5 text-[var(--aa-text-2)] max-w-xl">Enter the email you signed up with and we&apos;ll send you a one-time link to choose a new password. The link expires in 1 hour.</p>

        {sent ? (
          <div className="aa-card aa-card-sage p-7 mt-10" data-testid="forgot-success">
            <div className="aa-eyebrow mb-2">Check your inbox</div>
            <p className="text-[var(--aa-text-2)] leading-relaxed">
              If an account exists for <strong>{email}</strong>, a reset link is on its way. Check your inbox (and your spam/promotions folder, just in case).
            </p>
            <div className="mt-5">
              <Link to="/login" data-testid="forgot-back-login" className="aa-cta-secondary">← Back to sign in</Link>
            </div>
          </div>
        ) : (
          <form onSubmit={submit} className="aa-card p-8 mt-10 space-y-5 max-w-md">
            <div>
              <label className="aa-eyebrow block mb-2">Email</label>
              <input
                data-testid="forgot-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border-b border-[var(--aa-elevated)] focus:border-[var(--aa-text)] outline-none py-3 text-base"
              />
            </div>
            {err && <div data-testid="forgot-error" className="text-sm text-[var(--aa-terra)]">{err}</div>}
            <button data-testid="forgot-submit" disabled={loading} className="aa-cta-primary w-full">
              {loading ? "Sending…" : "Send reset link"}
            </button>
            <div className="text-sm text-[var(--aa-text-3)]">
              <Link to="/login" data-testid="forgot-to-login" className="underline underline-offset-4">← Back to sign in</Link>
            </div>
          </form>
        )}
      </section>
    </div>
  );
}
